import type { AppProps } from "next/app";
import Head from "next/head";
import { useEffect } from "react";
import dynamic from "next/dynamic";
import Script from "next/script";
import Image from "next/image";
import { Router } from "next/router";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

const PixelTracker = dynamic(() => import("../shared/pixel"), { ssr: false });

export default function MyApp({ Component, pageProps }: AppProps) {
  useEffect(() => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("init", "1434023414642911");
      window.fbq("track", "PageView");
    }
  }, []);

  useEffect(() => {
    posthog.init("phc_UO3EGu4jbmLbD6swRLS02ZwpKPI1WOejnWTvTCLvaft" as string, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com',
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      loaded: (posthogInstance) => {
        if (process.env.NODE_ENV === "development") {
          posthogInstance.debug();
        }
      },
    });

    const handleRouteChange = () => posthog?.capture("$pageview");
    Router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      Router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);

  return (
    <PostHogProvider client={posthog}>
      <>
        <Head>
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Head>

        {/* Facebook Pixel Script */}
        <Script id="facebook-pixel" strategy="afterInteractive">
          {`
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '1434023414642911');
            fbq('track', 'PageView');
          `}
        </Script>

        {/* Google Analytics */}
        <Script
          strategy="afterInteractive"
          src="https://www.googletagmanager.com/gtag/js?id=G-JHW6867LNN"
        />
        <Script id="google-analytics" strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-JHW6867LNN');
          `}
        </Script>

        <noscript>
          <Image
            height="1"
            width="1"
            style={{ display: "none" }}
            alt="Fb pixel"
            src="https://www.facebook.com/tr?id=1434023414642911&ev=PageView&noscript=1"
          />
        </noscript>

        <PixelTracker />
        <Component {...pageProps} />
      </>
    </PostHogProvider>
  );
}
